import type { StripeElementsOptions } from '@stripe/stripe-js';

export const appearance: StripeElementsOptions['appearance'] = {
  variables: {
    fontFamily: 'reMarkableSans, Helvetica, sans-serif',
    fontSizeBase: '16px',
    spacingGridRow: '1.5rem',
    spacingGridColumn: '1.5rem',
    fontSizeSm: '16px', // label size
    borderRadius: '4px',
  },
  rules: {
    '.Input': {
      padding: '16px',
      border: '1px solid #D2CABC',
      boxShadow: 'none',
      lineHeight: '16px',
      backgroundColor: '#fff',
    },
    '.Input:focus': {
      outline: '2px solid initial inset',
      boxShadow: 'none',
    },
    '.Input--invalid': {
      boxShadow: '0 0 0 2px var(--colorDanger) inset',
    },
    '.Label': {
      fontWeight: '500',
    },
    '.Error': {
      color: 'rgb(237, 27, 35)',
    },
    '.RadioIcon': {
      width: '32px',
    },
    '.RadioIconOuter': {
      fill: '#EFEFEF',
    },
    '.RadioIconInner': {
      r: '20px',
    },
    '.AccordionItem': {
      border: 'none',
      fontSize: '16px',
      fontWeight: '400',
      backgroundColor: 'rgb(249, 246, 241)',
    },
    '.TermsText': {
      fontSize: '12px',
      fontWeight: '400',
      color: '#211E1C',
    },
  },
};
